/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ResolveMergeRequest} from '@cash-web/protos/squareup/franklin/app/merge.pb'
import {ResolveMergeResponse} from '@cash-web/protos/squareup/franklin/app/merge.pb'


export const resolveMerge = (request:ResolveMergeRequest, options?: CashRequestOptions) => post<ResolveMergeRequest, ResolveMergeResponse>("/2.0/cash/resolve-merge", request, {...options, rejectOnError: true })